// Karton Flavor Selector functionality
function initializeKartonFlavorSelector(container = document) {
    console.log('Initializing Karton Flavor Selector');
    // DOM Elements - scoped to container
    const flavorButtons = container.querySelectorAll('#SingleOptionSelector-Flavours input');
    const flavorInputs = container.querySelectorAll('.flavor-quantity-input');
    const productForm = container.querySelector('form[action*="/cart/add"]') || container.querySelector('product-form form');
    const addToCartButton = container.querySelector('button[type="submit"][name="add"]');
    const flavorInputsContainer = container.querySelector('#SingleOptionSelector-Mixed-Flavours');

    // Configuration
    const maxQuantityElement = container.querySelector('#SingleOptionSelector-Quantity input');
    const maxQuantity = maxQuantityElement ? parseInt(maxQuantityElement.value.replace(/\D/g, '')) || 12 : 12;
    let totalQuantity = 0;

    // Early return if required elements not found
    if (!flavorInputs.length || !productForm || !addToCartButton) return;

    // ===== UTILITY FUNCTIONS =====

    function calculateTotal() {
        totalQuantity = 0;
        flavorInputs.forEach((input) => {
            totalQuantity += parseInt(input.value) || 0;
        });
        return totalQuantity;
    }

    function isMixedSelected() {
        return container.querySelector('#SingleOptionSelector-Flavours input[value="Mixed"]:checked');
    }

    // ===== MAIN FUNCTIONS =====

    function updateAddToCartButton() {
        calculateTotal();
        const mixedSelected = isMixedSelected();

        if (mixedSelected && totalQuantity !== maxQuantity) {
            addToCartButton.disabled = true;
            addToCartButton.setAttribute('disabled', true);
        } else {
            addToCartButton.disabled = false;
            addToCartButton.removeAttribute('disabled');
        }
    }

    function toggleFlavorInputsVisibility(showInputs) {
        if (!flavorInputsContainer) return;

        if (showInputs) {
            flavorInputsContainer.classList.remove('hidden');
            flavorInputsContainer.style.visibility = 'visible';
            flavorInputsContainer.style.height = flavorInputsContainer.scrollHeight + 'px';
        } else {
            flavorInputsContainer.classList.add('hidden');
            // Clear all flavor inputs when hiding
            flavorInputs.forEach((input) => {
                input.value = 0;
                input.removeAttribute('name');
            });
        }
        updateAddToCartButton();
    }

    function updateCartProperties() {
        const selectedFlavors = [];
        calculateTotal();

        // Update each flavor input
        flavorInputs.forEach((input) => {
            const quantity = parseInt(input.value) || 0;
            const flavorName = input.dataset.flavor;

            // Set dynamic max values
            let otherTotal = 0;
            flavorInputs.forEach((otherInput) => {
                if (otherInput !== input) {
                    otherTotal += parseInt(otherInput.value) || 0;
                }
            });
            input.setAttribute('max', maxQuantity - otherTotal);

            // Remove existing hidden input
            const existingInput = productForm.querySelector(`input[name="properties[${flavorName}]"]`);
            if (existingInput) existingInput.remove();

            if (quantity > 0) {
                selectedFlavors.push(`${flavorName}: ${quantity}`);

                // Add name attribute to original input
                input.setAttribute('name', `properties[${flavorName}]`);

                // Create hidden input for form submission
                const hiddenInput = document.createElement('input');
                hiddenInput.type = 'hidden';
                hiddenInput.name = `properties[${flavorName}]`;
                hiddenInput.value = quantity.toString();
                productForm.appendChild(hiddenInput);
            } else {
                input.removeAttribute('name');
            }
        });

        // Update consolidated note
        const existingNote = productForm.querySelector('input[name="properties[Karton Selection]"]');
        if (existingNote) existingNote.remove();

        if (selectedFlavors.length > 0) {
            const noteInput = document.createElement('input');
            noteInput.type = 'hidden';
            noteInput.name = 'properties[Karton Selection]';
            noteInput.value = `Mixed Karton (${totalQuantity} total): ${selectedFlavors.join(', ')}`;
            productForm.appendChild(noteInput);
        }

        updateAddToCartButton();
    }

    // ===== EVENT LISTENERS =====

    // Flavor variant change handlers
    flavorButtons.forEach((button) => {
        // Handle initial state
        if (button.checked) {
            toggleFlavorInputsVisibility(button.value === 'Mixed');
        }

        button.addEventListener('change', () => {
            totalQuantity = 0; // Reset total when variant changes
            toggleFlavorInputsVisibility(button.value === 'Mixed');
        });
    });

    // Flavor quantity change handlers
    flavorInputs.forEach((input) => {
        input.addEventListener('change', updateCartProperties);
        input.addEventListener('input', updateCartProperties);
    });

    // All variant selector change handlers
    const variantSelectors = container.querySelectorAll('[id^="SingleOptionSelector-"]');
    variantSelectors.forEach((selector) => {
        if (selector.tagName === 'SELECT') {
            selector.addEventListener('change', () => {
                totalQuantity = 0; // Reset total when variant changes
                // Clear all flavor input values when any variant changes
                flavorInputs.forEach((input) => {
                    input.value = 0;
                    input.removeAttribute('name');
                });
                setTimeout(updateAddToCartButton, 100);
            });
        } else {
            const radioInputs = selector.querySelectorAll('input[type="radio"]');
            radioInputs.forEach((radio) => {
                radio.addEventListener('change', () => {
                    totalQuantity = 0; // Reset total when variant changes
                    // Clear all flavor input values when any variant changes
                    flavorInputs.forEach((input) => {
                        input.value = 0;
                        input.removeAttribute('name');
                    });
                    setTimeout(updateAddToCartButton, 100);
                });
            });
        }
    });

    // ===== MUTATION OBSERVER FOR BUTTON STATE ENFORCEMENT =====

    const observer = new MutationObserver(() => {
        const mixedSelected = isMixedSelected();
        if (mixedSelected) {
            const currentTotal = calculateTotal();
            if (currentTotal !== maxQuantity && !addToCartButton.disabled) {
                addToCartButton.disabled = true;
                addToCartButton.setAttribute('disabled', true);
            }
        }
    });

    observer.observe(addToCartButton, {
        attributes: true,
        attributeFilter: ['disabled']
    });

    // ===== INITIALIZATION =====

    updateCartProperties();
    updateAddToCartButton();
}

// Make function globally available
window.initializeKartonFlavorSelector = initializeKartonFlavorSelector;

// Initialize on page load
document.addEventListener('DOMContentLoaded', function () {
    initializeKartonFlavorSelector();
});